export default {"src":"/_next/static/media/BUNDLES_PROJECT_LOCATION.199df205.svg","height":11,"width":8,"blurWidth":0,"blurHeight":0};